export default class WeekMode {
    constructor(name) {
        this.name = name;
    }

    toString() {
        return `WorkWeekMode.${this.name}`;
    }
}

WeekMode.WorkWeek = new WeekMode('WORK');

WeekMode.WholeWeek = new WeekMode('WHOLE');


// WEBPACK FOOTER //
// ./src/enums/weekMode.js